module.exports = __webpack_public_path__ + "static/media/mollie.38ed1b6c.png";